import React from "react";
import { Outlet } from "react-router-dom";
const employeeComponent = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default employeeComponent
